import { useZodForm } from '../../../../hooks/useZodForm.ts';
import { schReconciliationSheetForm } from '../schemas.ts';

export const useReconciliationSheetForm = () =>
  useZodForm({
    schema: schReconciliationSheetForm,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {},
  });
